<template>
  <v-dialog
    v-model="dialog"
    width="50%"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  ><v-form ref="form" v-model="valid" @submit.prevent="submit()">    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <alert-message></alert-message>
          <v-tabs v-model="tab">
            <v-tab> File Info </v-tab>
            <v-tab> Permissions </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <span class="subtitle-1">Path</span>
                      <br />
                      <span v-for="(folder, i) in path" :key="folder.name">
                        <span v-if="i !== 0" class="mx-1"><small>/</small></span>
                        <span>{{ folder.name }}</span>
                      </span>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field
                        v-model="form.notes"
                        label="Notes"
                        :error-messages="[].concat(fieldErrors('form.notes'))"
                        @blur="$v.form.notes.$touch()"
                      />
                    </v-col>
                  </v-row>
                  <v-row v-if="!isEdit">
                    <v-col>
                      <DropzoneUpload v-model="files" />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-row>
                <v-col>
                  <PermissionSelect v-model="permissions" />                  
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs-items>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="darken-1" @click="dialog = false">Cancel</v-btn>
        <v-btn
          :disabled="$v.$invalid"
          type="submit"
          color="info"
          :loading="loading"
        >
          {{ isEdit ? "Save" : "Upload" }}
        </v-btn>
      </v-card-actions>
    </v-card>    </v-form>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
import AlertMessage from "src/components/AlertMessage";
import validationMixin from "@/mixins/validationMixin";
import formatterMixin from "@/mixins/formatterMixin";
import PermissionSelect from "components/PermissionSelect";
import DropzoneUpload from "./_DropzoneUpload.vue";

const defaultInputs = {
  id: 0,
  accountId: 0,
  name: "",
  notes: "",
  tags: [],
  permissions: [],
};

export default {
  components: {
    AlertMessage,
    PermissionSelect,
    DropzoneUpload,
  },
  props: {
    clientId: Number,
    item: Object,
    path: Array,
    show: [Boolean, String],
  },
  mixins: [validationMixin, formatterMixin],
  validations: {
    form: {
      id: {},
      name: {},
      accountId: {},
      file: {},
      notes: {},
      tags: {},
    },
  },
  validationMessages: {
    form: {
      id: {},
      clientId: { required: "Required" },
      accountId: {},
      file: {},
      name: { required: "Required" },
      notes: { required: "Required" },
      tags: {},
    },
  },

  data() {
    return {
      showDialog: this.show,
      form: {
        ...defaultInputs,
      },
      dialog: false,
      valid: false,
      loading: false,
      fileValue: undefined,
      fileLoaded: 0,
      permissions: [],
      files: [],
      readedFiles: [],
      tab: null
    };
  },

  watch: {
    show(n, o) {
      if (n && !o) {
        this.dialog = true;
      }
    },

    dialog(n, o) {
      if (!n && o) {
        this.onDialogClose();
      } else {
        this.onDialogOpen();
      }
    },

    files(newfiles) {
      this.readedFiles = [];
      if (newfiles.length > 0) {
        newfiles.map((file) => this.readFile(file));
      }
    },

    item(newTask, oldTask) {
      if (newTask && JSON.stringify(newTask) !== JSON.stringify(oldTask)) {
        let tags = [];
        if (newTask.categories && newTask.categories.length > 0) {
          tags = newTask.categories.map((i) => i.id);
        }
        if (this.isEdit) {
          this.permissions = newTask.permissions;
        } else {
          this.permissions = this.defaultItems;
        }
        this.form = {
          ...newTask,
          tags,
          permissions: this.permissions,
        };
      } else {
        this.permissions = this.defaultItems;
        this.form = {
          ...defaultInputs,
          permissions: this.defaultItems,
        };
      }
    },
  },

  computed: {
    ...mapState({
      account: (state) => state.account,
      userGroups: (state) => state.userGroup.data,
      user: (state) => state.account.data.user,
      storage: (state) => state.storage,
      alert: (state) => state.alert,
    }),

    defaultItems() {
      let items = [];
      this.userGroups.forEach((item) => {
        const isAdmin = item.name === "Super Admin"
        const isIntendant = item.name === "Superintendant"
        const isManager = item.name === "Field Manager"
        
        items.push({
          userGroupId: item.id,
          userGroupName: item.name,
          userActionId: 1, // view access
          access: true
        });
        items.push({
          userGroupId: item.id,
          userGroupName: item.name,
          userActionId: 3, // edit access
          access: isAdmin || isIntendant || isManager
        });
        items.push({
          userGroupId: item.id,
          userGroupName: item.name,
          userActionId: 4, // delete access
          access: isAdmin
        });
      });
      return items;
    },

    getAdminGroup() {
      let found = this.userGroups.filter((item) => item.name == "Super Admin");
      if (found.length === 1) {
        return found[0];
      } else {
        return null;
      }
    },

    formTitle() {
      return this.isEdit ? `Edit File "${this.item.name}"` : "Upload New File";
    },
    isEdit() {
      return this.item && this.item.id ? true : false;
    },
    taskId() {
      return this.optional(this.item, "id", "");
    },
    folderId() {
      const folderId = this.path[this.path.length - 1].id;
      return folderId;
    },
  },

  methods: {
    ...mapActions("storage", ["upload", "update"]),

    initForm() {
      if (this.clientId) {
        this.form = {
          ...this.form,
        };
      }
    },

    onDialogClose() {
      if (this.isEdit) {
        //
      } else {
        //
      }
      this.permissions = [];
      this.files = [];
      this.$emit("onClosed");
    },

    onDialogOpen() {
      this.$store.dispatch("alert/clear");
      this.initForm();
    },

    save() {},
    addNew() {
      this.dialog = true;
      this.form = {
        ...defaultInputs,
      };
    },
    completed() {
      this.permissions = [];
      this.$emit("onSucceded");
    },

    readFile(file) {
      this.fileLoaded = 0;
      const reader = new FileReader();
      reader.addEventListener("load", (event) => {
        const result = event.target.result;
        this.readedFiles.push(result);
      });

      reader.addEventListener("progress", (event) => {
        if (event.loaded && event.total) {
          // const percent = (event.loaded / event.total) * 100;
          // this.fileLoaded = Math.round(percent);
        }
      });
      if (file) {
        reader.readAsArrayBuffer(file);
      }
    },

    async submit() {
      this.loading = true;

      if (this.isEdit) {
        let payload = {
          ...this.form,
          folderId: this.folderId,
        };
        delete payload.file;
        await this.update({
          id: this.taskId,
          ...payload,
          permissions: this.permissions,
        });
      } else {
        const formData = new FormData();
        let isAnyCorruptedFile = false;
        this.files.map((file) => {
          if (file instanceof Blob) {
            formData.append("Files", file);
          } else {
            alert("Seems this file is corrupted\n" + file.name);
            isAnyCorruptedFile = true;
          }
        });

        if (isAnyCorruptedFile) {
          this.loading = false;
          this.permissions = [];
          return false;
        }

        formData.append("FolderId", this.folderId);
        if (this.form.notes) {
          formData.append("Notes", this.form.notes);
        }
        this.form.tags.map((tag) => {
          formData.append("Tags", tag);
        });
        if (this.permissions && this.permissions.length > 0) {
          this.permissions.map((permission) => {
            formData.append("Permissions", JSON.stringify(permission));
          });
        }
        await this.upload(formData);
      }

      if (!this.storage.status.error) {
        this.dialog = false;
        this.completed();
      }
      this.loading = false;
      this.permissions = [];
    },
  },
};
</script>

<style scoped>
.dropzone-custom-content {
  text-align: center;
}

.dropzone-custom-title {
  margin-top: 0;
  color: #00b782;
}

.subtitle {
  color: #314b5f;
}
</style>